// extracted by mini-css-extract-plugin
export default {"price":"n7-z","priceRow":"o7-z","onSale":"p7-z","msrpLabelPrice":"q7-z","msrpLabel":"r7-z","originalPrice":"s7-z","percentOff":"t7-z"};